import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

import { DailyLogViewSections } from "entity/dailyLog/DailyLogView/DailyLogView.api.types";

interface IDailyLogParams {
    id: number;
    jobId: number;
}

interface IDailyLogSectionParams {
    section?: DailyLogViewSections;
}

interface IDailyLogQueryParams {
    commentId?: number;
}

export const dailyLogViewPath = "/DailyLogView/:id/:jobId/:section?";
export const dailyLogViewRoute = createRoute<
    IDailyLogParams & IDailyLogSectionParams,
    IDailyLogQueryParams
>(getPathForAllPortals(dailyLogViewPath), "Daily Log", {
    section: DailyLogViewSections.none,
});

export const dailyLogEditPath = "/DailyLog/:id/:jobId";
export const dailyLogEditRoute = createRoute<IDailyLogParams>(
    getPathForAllPortals(dailyLogEditPath),
    "Daily Log Edit",
);

export const dailyLogAddPath = "/DailyLogAdd/:jobId";
export const dailyLogAddRoute = createRoute<{ jobId: number }>(
    getPathForAllPortals(dailyLogAddPath),
    "Add Daily Log",
);
